import { TextInput as MTextInput, type TextInputProps } from "@mantine/core";
import type React from "react";
import inputsClassnames from "./InputClassnames";

interface IInputProps {
  label?: string | React.ReactNode;
  value: string;
  placeholder?: string;
  className?: string;

  onChange: (value: string | null) => void;
}

const SSTextInput: React.FC<IInputProps & TextInputProps> = ({
  label,
  value,
  onChange,
  className,
  placeholder,
  ...rest
}) => {
  return (
    <MTextInput
      {...rest}
      className={className}
      classNames={inputsClassnames}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
    />
  );
};

export default SSTextInput;
